import { render, staticRenderFns } from "./ProjectActions.vue?vue&type=template&id=2e7dfaa0&scoped=true"
import script from "./ProjectActions.vue?vue&type=script&lang=js"
export * from "./ProjectActions.vue?vue&type=script&lang=js"
import style0 from "./ProjectActions.vue?vue&type=style&index=0&id=2e7dfaa0&prod&scoped=true&lang=css"
import style1 from "./ProjectActions.vue?vue&type=style&index=1&id=2e7dfaa0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7dfaa0",
  null
  
)

export default component.exports